import React from "react";
import rcss from "../../../../Styles/reports.module.css"
import { EncodingResults } from "../../SearchResultsObserver";
import { SearchResultDetailsView } from "./SearchResultDetailsView";
import { InteractiveRequestIdBaseProps } from "../../InteractiveRequestId";
import { GetsDbEventsByIndex } from "../../../../State/EvidenceDB/DbEventCache";
import type { HasCallStackResolution } from "../../../../lib/Causation/CallStackResolution";
import { SearchDetailsRenderOnFirstExpand } from "../../../../Styles/ReportStyles";
import { HasLicensePermissions } from "../../../../State/EvidenceDB/LicensePermissions";

export const EncodingDetailsView = ({
	encodingResults, getsDbEventsByIndex, ...interactiveRequestIdBaseProps
}: InteractiveRequestIdBaseProps & HasCallStackResolution & HasLicensePermissions &  {
	encodingResults: EncodingResults;
	getsDbEventsByIndex: GetsDbEventsByIndex;	
}) => {
	const { encodingString, eventsAndResults } = encodingResults;
	// If there are four or fewer events, show them all.
	// If there are more than four events, show the first three and expand the remaining ones.
	const eventsAndResultsEntries = [...eventsAndResults.entries()]
	const numberOfEventsToAlwaysShow = eventsAndResultsEntries.length <= 4 ? eventsAndResultsEntries.length : 3;
	const eventsToAlwaysShow = eventsAndResultsEntries.slice(0, numberOfEventsToAlwaysShow);
	const eventsToBeRevealedWhenExpanded = eventsAndResultsEntries.slice(numberOfEventsToAlwaysShow);
	return (
		<div className={rcss.indented} key={encodingString}>
			<div className={rcss.searchResultFoundLine}><span className={rcss.searchResultEncodingFoundSpan}>{encodingString}</span>&#32;found at…</div>
			{eventsToAlwaysShow.map(([key, result]) => (
				<SearchResultDetailsView key={key} {...{result, getsDbEventsByIndex, ...interactiveRequestIdBaseProps}} />
			))}
			{eventsToBeRevealedWhenExpanded.length === 0 ? null : (
				<SearchDetailsRenderOnFirstExpand key={encodingString} deferredRenderOnExpand={() => (<>{eventsToBeRevealedWhenExpanded.map(([key, result]) => (
							<SearchResultDetailsView key={key} {...{result, getsDbEventsByIndex, ...interactiveRequestIdBaseProps}} />
						))}
						</>)
					}>
					<summary>and&#32;{eventsToBeRevealedWhenExpanded.length}&#32;additional occurrences</summary>
				</SearchDetailsRenderOnFirstExpand>
			)}
		</div>
	);
};
